import { render, staticRenderFns } from "./WorkSettingsForm.vue?vue&type=template&id=351cfac4"
import script from "./WorkSettingsForm.vue?vue&type=script&lang=js"
export * from "./WorkSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports